import TripsTab from './Tabs/TripsTab';
import PaymentsTab from './Tabs/PaymentsTab';
import MonthlyBalancesTab from './Tabs/MonthlyBalancesTab';
import PartyProfileTab from './Tabs/PartyProfileTab';
const baseUrl = "/parties/single-party";
export default {
  tabs: [
    {
      path: baseUrl + '/trips/',
      name: 'Trips',
      type: 'tab',
      component: TripsTab,
      state: {
        id: 1,
        pageTitle: 'Trips'
      }
    },
    {
      path: baseUrl + '/passbook/',
      name: 'Passbook',
      type: 'tab',
      component: PaymentsTab,
      state: {
        id: 1,
        pageTitle: 'Passbook'
      }
    },
    {
      path: baseUrl + '/monthly-balances/',
      name: 'Monthly Balances',
      type: 'tab',
      component: MonthlyBalancesTab,
      state: {
        id: 1,
        pageTitle: 'MonthlyBalancesTab'
      }
    },
    {
      path: baseUrl + '/party-profile/',
      name: 'Party Details',
      type: 'tab',
      component: PartyProfileTab,
      state: {
        id: 1,
        pageTitle: 'PartyProfileTab'
      }
    }
  ]
};